export const OFFICE_LOCATION = { lng: 46.7043346, lat: 24.7427167 };
export const METRO_LOCATION = { lng: 46.6956972, lat: 24.74057 };
